import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put, select } from 'redux-saga/effects';
import { selectEntity } from '../../selectors/policy/selectEntity';

export function* chargeCardSaga() {
    try {
        yield put(reduceLoading({ code: 'chargeCard', value: true }));
        const session = yield getSessionSaga();
        const entity = yield select(selectEntity());

        const response = yield call(fetch, `/api/payment/capture-authorization/${entity}`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
        });

        const result = yield call([response, 'json']);

        yield put(reduceOperation(result.operation));

        window.location.reload();
    } catch (error) {
        console.log('Error while calling Charge Card API - ', error);
        yield put(
            reduceOperation({
                status: false,
            }),
        );
    } finally {
        yield put(reduceLoading({ code: 'chargeCard', value: false }));
    }
}
